module.exports = __webpack_public_path__ + "img/home5.93c26279.png";